// Copyright (c) 2025 IOTA Stiftung
// SPDX-License-Identifier: Apache-2.0

import { ExternalLink } from '../types/link';

export const LEGAL_LINKS: ExternalLink[] = [
    {
        text: 'Terms & Conditions',
        url: 'https://www.iota.org/terms-of-use',
        isExternal: true,
    },
    {
        text: 'Privacy Policy',
        url: 'https://www.iota.org/privacy-policy',
        isExternal: true,
    },
    {
        text: 'Cookie Policy',
        url: '/cookie-policy',
    },
];
